<template>
    <div>
        <PageSpinner :onloader="onloader" />
        <base-header type="gradient-success" class="pb-6 pb-8 pt-5 pt-md-8">
            <router-link to="/dashboard" class="text-white">Dashboard</router-link>
            <router-link to="/school/finance-management" class="text-white">
                <i class="fa fa-ellipsis-v mx-2"></i>Finance Management
            </router-link>
            <span class="text-white"><i class="fa fa-ellipsis-v mx-2"></i>Fee Structure</span>
        </base-header>

        <!--Charts-->
        <div class="container-fluid mt--7">
            <div class="mb-5 mb-xl-0">
                <modal :show.sync="modals.feeNameModal" modal-classes="modal-dialog-centered">
                    <div class="card border-0 mb-0">
                        <div class="card-body">
                            <form role="form">
                                <div class="form-group">
                                    <label>Bill Name</label>
                                    <input v-model="BillNameval" class="form-control" placeholder="Enter Bill Name" />
                                </div>

                                <div class="text-center mb-3">
                                    <base-button type="default" @click="modals.feeNameModal = false">Cancel
                                    </base-button>
                                    <base-button type="success" @click.prevent="SubmitFeeName()">Submit
                                    </base-button>
                                </div>
                            </form>
                            <div class="table-responsive mt-2">
                                <table class="table table-bordered table-striped table-hover">
                                    <thead>
                                        <tr>
                                            <th>Bill Name</th>
                                            <th></th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="item in resultItems" :key="item.Id">
                                            <td>{{ item.BillName }}</td>
                                            <td>
                                                <button class="btn btn-secondary btn-sm" v-on:click="editFeeName(item)">
                                                    <i class="fa fa-edit"></i> Edit
                                                </button>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </modal>

                <card header-classes="bg-transparent">
                    <div class="row">
                        <div class="col-md-6">
                            <div class="card bg-secondary border-0 mb-0">
                                <div class="card-body">
                                    <div class="form-horizontal">
                                        <form role="form" @submit.prevent="SubmitFeeStucture">
                                            <div class="card bg-gradient-secondary">
                                                <div class="card-body">
                                                    <div class="row">
                                                        <div class="col-md-6">
                                                            <div class="form-group">
                                                                <label>Session</label>
                                                                <select v-model="SessionIdval" class="form-control"
                                                                    @change="getregterm()" :disabled="!Sessionitems">
                                                                    <option v-if="!Sessionitems" value="">⏳ Loading...
                                                                    </option>
                                                                    <option v-else value="0">- Select Session -</option>
                                                                    <option v-for="item in Sessionitems" :key="item.Id"
                                                                        v-bind:value="item.Id">
                                                                        {{ item.SchSession }}
                                                                    </option>
                                                                </select>
                                                            </div>
                                                        </div>
                                                        <div class="col-md-6" v-if="SessionIdval">
                                                            <div class="form-group">
                                                                <label>Term</label>
                                                                <select v-model="TermIdval" class="form-control"
                                                                    @change="getclass()" :disabled="!termitems">
                                                                    <option v-if="!termitems" value="0">⏳ Loading...
                                                                    </option>
                                                                    <option v-else value="0">- Select Term -</option>
                                                                    <option v-for="item in termitems" :key="item.Id"
                                                                        v-bind:value="item.Id">
                                                                        {{ item.SchTerm }}
                                                                    </option>
                                                                </select>
                                                            </div>
                                                        </div>
                                                        <div class="col-md-6" v-if="TermIdval">
                                                            <div class="form-group">
                                                                <label>Class</label>
                                                                <select v-model="ClassIdval" class="form-control"
                                                                    @change="getoption()" :disabled="!classitems">
                                                                    <option v-if="!classitems" value="0">⏳ Loading...
                                                                    </option>
                                                                    <option v-else value="0">- Select Class -</option>
                                                                    <option v-for="item in classitems" :key="item.Id"
                                                                        v-bind:value="item.Id">
                                                                        {{ item.Sch_Class }}
                                                                    </option>
                                                                </select>
                                                            </div>
                                                        </div>
                                                        <div class="col-md-6" v-if="ClassIdval">
                                                            <div class="form-group">
                                                                <label>Option</label>
                                                                <select v-model="OptionIdval" class="form-control"
                                                                    @change="getallschoolbilldetails()"
                                                                    :disabled="!optionitems">
                                                                    <option v-if="!optionitems" value="0">⏳ Loading...
                                                                    </option>
                                                                    <option v-else value="0">- Select Option -</option>
                                                                    <option v-for="item in optionitems" :key="item.Id"
                                                                        v-bind:value="item.Id">
                                                                        {{ item.ClassOption }}
                                                                    </option>
                                                                </select>
                                                            </div>
                                                        </div>

                                                        <div class="col-md-6" v-if="OptionIdval">
                                                            <div class="form-group">
                                                                <label>Bill Name</label>
                                                                <select v-model="BillNameIdval" class="form-control"
                                                                    :disabled="!billNameItems">
                                                                    <option v-if="!billNameItems" value="0">⏳ Loading...
                                                                    </option>
                                                                    <option v-else value="0">- Select Bill Name -
                                                                    </option>
                                                                    <option v-for="item in billNameItems" :key="item.Id"
                                                                        v-bind:value="item.Id">
                                                                        {{ item.BillName }}
                                                                    </option>
                                                                </select> <button class="btn btn-secondary btn-sm" @click.prevent="OpenNewFeeName()">Add Bill Name</button>
                                                            </div>
                                                        </div>
                                                        <div class="col-md-6" v-if="BillNameIdval">
                                                            <div class="form-group">
                                                                <label>Bill Amount</label>
                                                                <input v-model="BillAmountval" class="form-control"
                                                                    required />
                                                            </div>
                                                        </div>
                                                        <div class="col-md-6" v-if="BillNameIdval">
                                                            <div class="form-group">
                                                                <label class="mr-4">Is Optional</label>
                                                                <input type="checkbox" v-model="IsOptionval" />
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="text-center mb-3" v-if="BillNameIdval">
                                                <button type="submit" class="btn btn-primary my-4">
                                                    Submit
                                                </button>
                                            </div>
                                        </form>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-6">
                            <span class=" badge badge-primary" v-if="sumResultItem">Total Amount = {{
                                sumResultItem
                            }}</span>
                            <div class="table-responsive mt-2" v-if="resultItems">
                                <table class="table table-bordered table-striped table-hover">
                                    <thead>
                                        <tr>
                                            <th>Bill Name</th>
                                            <th>BillAmount</th>
                                            <th></th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="item in resultItems" :key="item.Id">
                                            <td>{{ item.BillName }}</td>
                                            <td>{{ item.BillAmount }}</td>
                                            <td>
                                                <button class="btn btn-secondary btn-sm"
                                                    v-on:click="EditFeeSetup(item)">
                                                    <i class="fa fa-edit"></i> Edit
                                                </button>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </card>
            </div>
            <!-- End charts-->
        </div>
    </div>
</template>

<script>
import moment from "moment";
import Alert from "@/mixins/Alert.mixins"
import PageSpinner from "@/components/PageSpinner"
export default {
    name: "SchooBillDetails",
    mixins: [Alert],
    components: {
        PageSpinner
    },
    data() {
        return {
            accessDetails: null,
            Idval: 0,
            FeeNameIdval: 0,
            ClassIdval: 0,
            OptionIdval: 0,
            SessionIdval: 0,
            TermIdval: 0,
            BillNameIdval: 0,
            IsOptionval: false,
            BillAmountval: "",
            Sessionitems: null,
            termitems: null,
            classitems: null,
            optionitems: null,
            billNameItems: null,
            sumResultItem: null,
            resultItems: null,
            BillNameval: "",
            process: "N",
            onloader: "none",
            modals: {
                feeNameModal: false
            }
        };
    },

    methods: {
        OpenNewFeeName() {
            this.FeeNameIdval = 0;
            this.BillNameval = "";
            this.process = "N";
            this.modals.feeNameModal = true;
        },
        EditFeeSetup(item) {
            this.Idval = item.Id;
            this.ClassIdval = item.ClassId;
            this.getoption();
            this.OptionIdval = item.ClassOptionId;
            this.SessionIdval = item.SessionId;
            this.getregterm();
            this.TermIdval = item.TermId;
            this.BillNameIdval = item.BillNameId;
            this.IsOptionval = item.IsOption;
            this.BillAmountval = item.BillAmount;
            this.process = "U";
        },
        editFeeName(item) {
            this.FeeNameIdval = item.Id;
            this.BillNameval = item.BillName;
            this.process = "U";
            this.modals.feeNameModal = true;
        },
        SubmitFeeStucture() {
            let Id = this.Idval;
            let BillNameId = this.BillNameIdval;
            let ClassOptionId = this.OptionIdval;
            let BillAmount = this.BillAmountval;
            let IsOption = this.IsOptionval;
            let SessionId = this.SessionIdval;
            let TermId = this.TermIdval;
            let processop = this.process;
            let username = this.$store.state.auth.username;
            let accesskey = this.$store.state.auth.accesskey;
            let userdata = {
                Id,
                BillNameId,
                ClassOptionId,
                BillAmount,
                IsOption,
                SessionId,
                TermId,
                processop,
                username,
                accesskey,
            };
            this.onloader = "flex";
            this.$store
                .dispatch("processschoolbilldetails", userdata)
                .then((resp) => {
                    this.resultItems = resp;
                    this.getsumschoolbilldetails();
                    this.BillNameIdval = 0;
                    this.BillAmountval = '';
                    this.IsOptionval = false;
                    this.process = 'N';
                    this.onloader = "none";
                    this.ShowAlertSuccess('Submitted Successfully', '');
                })
                .catch((err) => {
                    this.onloader = "none";
                    this.ShowAlertError(err.response.data, '');
                });
        },
        SubmitFeeName() {
            let BillName = this.BillNameval;
            let Id = this.FeeNameIdval;
            let processop = this.process;
            let username = this.$store.state.auth.username;
            let accesskey = this.$store.state.auth.accesskey;
            this.onloader = "flex";
            let payload = {
                Id,
                BillName,
                processop,
                username,
                accesskey,
            };
            this.$store
                .dispatch("processschoolbill", payload)
                .then((resp) => {
                    this.FeeNameItems = resp;
                    this.onloader = "none";
                    this.ShowAlertSuccess('Submitted Successfully', '');
                })
                .catch((err) => {
                    this.onloader = "none";
                    this.ShowAlertError(err.response.data, '');
                });
        },
        getallschoolbilldetails() {
            if (this.OptionIdval) {
                let ClassOptionId = this.OptionIdval;
                let SessionId = this.SessionIdval;
                let TermId = this.TermIdval;
                let userdata = {
                    ClassOptionId,
                    SessionId,
                    TermId,
                };
                this.onloader = "flex";
                this.$store
                    .dispatch("getallschoolbilldetails", userdata)
                    .then((resp) => {
                        this.resultItems = resp;
                        this.getsumschoolbilldetails();
                        this.onloader = "none";
                    })
                    .catch((err) => {
                        this.onloader = "none";
                        this.ShowAlertError(err.response.data, '');
                    });
            }
        },
        getsumschoolbilldetails() {
            if (this.OptionIdval) {
                let ClassOptionId = this.OptionIdval;
                let SessionId = this.SessionIdval;
                let TermId = this.TermIdval;
                let userdata = {
                    ClassOptionId,
                    SessionId,
                    TermId,
                };
                this.onloader = "flex";
                this.$store
                    .dispatch("getsumschoolbilldetails", userdata)
                    .then((resp) => {
                        this.sumResultItem = resp;
                        this.onloader = "none";
                    })
                    .catch((err) => {
                        this.onloader = "none";
                        this.ShowAlertError(err.response.data, '');
                    });
            }
        },
        getregsession() {
            this.termitems = null;
            this.Sessionitems = null;
            this.SessionIdval = 0;
            this.onloader = "flex";
            this.$store
                .dispatch("getregsession")
                .then((resp) => {
                    this.Sessionitems = resp;
                    this.onloader = "none";
                })
                .catch((err) => {
                    console.log(err);
                    this.onloader = "none";
                    this.$store.dispatch("logout");
                    this.$router.push("/home");
                });
        },
        getregterm() {
            this.termitems = null;
            this.TermIdval = 0;
            let SessionId = this.SessionIdval;
            if (SessionId > 0) {
                this.onloader = "flex";
                this.$store
                    .dispatch("getregterm", SessionId)
                    .then((resp) => {
                        this.termitems = resp;
                        this.onloader = "none";
                    })
                    .catch((err) => {
                        this.onloader = "none";
                        this.ShowAlertError(err.response.data, '');
                    });
            }
        },
        getclass() {
            this.classitems = null;
            this.optionitems = null;
            this.ClassIdval = 0;
            this.onloader = "flex";
            this.$store
                .dispatch("getclass")
                .then((resp) => {
                    this.classitems = resp;
                    this.onloader = "none";
                })
                .catch((err) => {
                    this.onloader = "none";
                    this.ShowAlertError(err.response.data, '');
                });
        },
        getoption() {
            this.optionitems = null;
            this.OptionIdval = 0;
            this.onloader = "flex";
            let ClassId = this.ClassIdval;
            if (ClassId > 0) {
                this.$store
                    .dispatch("getoption", ClassId)
                    .then((resp) => {
                        this.optionitems = resp;
                        this.onloader = "none";
                    })
                    .catch((err) => {
                        this.onloader = "none";
                        this.ShowAlertError(err.response.data, '');
                    });
            }
        },
        getallschoolbill() {
            this.$store
                .dispatch("getallschoolbill")
                .then((resp) => {
                    this.billNameItems = resp;
                    this.onloader = "none";
                })
                .catch((err) => {
                    this.onloader = "none";
                    this.ShowAlertError(err.response.data, '');
                });
        },
        frontEndDateFormat(date) {
            return moment(date).format("YYYY-MM-DD");
        },
        backEndDateFormat(date) {
            return moment(date, "DD/MM/YYYY").format("YYYY-MM-DD");
        },
    },
    mounted() {
        this.accessDetails = this.$store.getters['auth/_user'];
        if (this.accessDetails.isSchoolStaff == false) {
            this.$store.dispatch('auth/Logout')
            this.$router.push('/login')
        } else {
            this.getregsession();
            this.getallschoolbill();
        }
    },
};
</script>

<style></style>
